/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="user-search">
    <a-button type="primary"
      block
      ghost
      @click="showSeachDialog"
    >
      <div v-if="selectedItem._id">
        <a-avatar shape="square" size="small" :src="selectedItem.headimgurl" style="margin-right:5px" />
      {{ selectedItem.nickname }}({{ selectedItem.company.name }})
      </div>
      <div v-else>
        选择用户
      </div>
    </a-button>
    <a-modal
      title="选择用户"
      width="760px"
      :visible="visible"
      :footer="null"
      @cancel="visible = false"
    >
    <div>
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
			<a-form-model-item>
				<a-input v-model="search.nickname" placeholder="输入微信昵称" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.mobile" placeholder="输入电话" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 300 }"
			:pagination="pager"
      rowKey="_id"
			@change="change">
			<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.headimgurl" />
          <span style="margin-left: 10px">{{ record.nickname }}</span>
			</span>
			<span slot="subscribe" slot-scope="text">
				<a-tag color="#87d068" v-if="text === 1">已关注</a-tag>
				<a-tag color="#f50" v-else>未关注</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
				<a-button type="primary"  @click="select(record)" :disabled="record.subscribe !== 1">选择</a-button>
			</span>
		</a-table>
    </div>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { getUserList, getWxUserDetail } from '@/api/user';

export default {
  props: ['placeholder', 'value', 'company'],
  data() {
    return {
      visible: false,
      dataSource: [],
      fetching: false,
      valtest: '',
      listloading: false,
      list: [],
      pager: {},
      search: {},
      selectedItem: {},
      searchRange: [],
    };
  },
  created() {
    const userId = this.value;
    if (userId) {
      this.getDetail(userId);
    }
  },
  computed: {
    // val: {
      // get() {
      //   return this.value;
      // },
      // set(val) {
      //   console.log(val);
      //   this.$emit('input', val);
      // },
    // },
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '公司',
          dataIndex: 'company.name',
          key: 'companyName',
        },
        {
          title: '用户昵称',
          dataIndex: 'user.nickName',
          key: 'nickName',
          scopedSlots: { customRender: 'user' },
        },
        {
          title: '电话',
          dataIndex: 'mobile',
          key: 'mobile',
        },
        {
          title: '是否关注',
          dataIndex: 'subscribe',
          scopedSlots: { customRender: 'subscribe' },
          key: 'subscribe',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 142,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
    selectItems: {
      get() {
        return this.value;
      },
    },
  },
  methods: {
    showSeachDialog() {
      this.visible = true;
      this.getList();
    },
    async getDetail(id) {
      const { data } = await getWxUserDetail(id);
      if (data) {
        this.selectedItem = data;
      } else {
        this.$message.error('没有用户数据请先关注相应公众号');
      }
    },
    select(val) {
      this.selectedItem = val;
      this.visible = false;
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('input', val._id);
    },
    async getList() {
      this.listloading = true;
      const q = { ...this.search, company: this.company };
      // eslint-disable-next-line prefer-destructuring
      q.start = this.searchRange[0];
      // eslint-disable-next-line prefer-destructuring
      q.end = this.searchRange[1];
      try {
        const { data: { docs, pager } } = await getUserList(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
